import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import { SuccessMessage } from "sr/helpers/functions/SuccessMessage";
import ApiResponse from "sr/models/ApiResponse";
import {put } from "sr/utils/axios";

export const updateCustomerLocation = async (putData:any) => {
    try {
  return await put<ApiResponse<[]>>('/customer/location', putData).then((res)=> {
    if(res.success===true) {
        SuccessMessage('API.SUCCESS.CUSTOMER.CUSTOMER.LOCATION.UPDATE')
        return res
    }
    else {
        return null
    }
  });
}
catch(e:any) {
    HandleApiError(e)
    }
}